<template>
  <div class="flex yxtbiz-rank-list__rank-title ml8 mr8" ref="rankTitle">
    <!-- 榜单名称 -->
    <slot name="title"></slot>
    <div
      v-if="!styleObject.hideTitle"
      class="flex-1 yxtbiz-rank-list__rank-title-default-title"
    >
      <div class="flex align-items-center">
        <yxtf-tooltip
          placement="top"
          open-filter
          class="ellipsis"
          :content="titleObj.title"
        >
          <span class="text-26 standard-size-16 yxtf-weight-6">{{
            titleObj.title
          }}</span>
        </yxtf-tooltip>
      </div>
    </div>
    <!-- 日期选择 -->
    <select-conditions class="ml24" @changeDate="$emit('changeDate', $event)" />
  </div>
</template>
<script>
import selectConditions from './selectConditions.vue';

export default {
  components: {
    selectConditions
  },
  inject: ['titleFun', 'styleFun'],
  computed: {
    // 榜单名称数据
    titleObj() {
      return this.titleFun();
    },
    // hideTitle 隐藏标题
    styleObject() {
      return this.styleFun();
    }
  }
};
</script>
<style lang="scss" scoped>
@import './index.scss';
</style>
